import './tabs.scss';

class Tabs {
    constructor (element) {
        this.$tabs = element;
        this.$tabsNav = this.$tabs.querySelector('[data-tabs-nav]');
        this.$tabsNavItems = this.$tabsNav.querySelectorAll('a');
        this.$tabsContents = this.$tabs.querySelector('[data-tabs-contents]');
        this.$tabsContent = this.$tabsContents.querySelectorAll('[data-tabs-content]');
        this.active = 0;
        this.scrollDistance = 0;

        this.init();
    }

    init () {
        this.setActiveTab(this.$tabsNavItems[0]);
        this.setEvents();
    }

    setEvents () {
        this.$tabsNavItems.forEach((tab) => {
            tab.addEventListener('click', e => {
                e.preventDefault();
                this.setActiveTab(tab);
            });
        });
    }

    setActiveTab (currentItem) {
        const $currentItem = currentItem;
        const currentItemWidth = $currentItem.offsetWidth;
        const currentItemLeft = $currentItem.offsetLeft;
        const windowWidth = window.offsetWidth;
        const targetId = $currentItem.getAttribute('href');
        const $target = this.$tabsContents.querySelector(targetId);

        this.scrollDistance = currentItemLeft - (windowWidth / 2) + (currentItemWidth / 2);

        this.$tabsNavItems.forEach(item => {
            item.classList.remove('is--active');
        });

        $currentItem.classList.add('is--active');

        this.$tabsContent.forEach(content => {
            content.classList.remove('is--active');
        });

        $target.classList.add('is--active');
    }
}

export { Tabs };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$tabs = $context.querySelectorAll('[data-tabs]');
        for (let i = 0; i < $$tabs.length; i++) {
            const $tabs = $$tabs[i];
            $tabs.tabsApi = new Tabs($tabs);
        }
    }
});
